
class FronteggService {
  constructor(options) {
    this.app = options.app;
  }

  subscribeToAuth(onInit, onAuthenticated, onUnAuthenticated) {
    this.app.ready(() => {
      onInit();
      this.app.store.subscribe(() => {
        const state = this.app.store.getState();
        if (!state.auth.isLoading) {

          if (!state.auth.isAuthenticated) {
            onUnAuthenticated();
          } else {
            onAuthenticated(state.auth);
          }
        }
      })
    });
  }
}


export { FronteggService }
